module.exports = __webpack_public_path__ + "static/media/tips-off.650fc67f.svg";